<template>
    <div>
        <transaction-filter
                :credits="credits"
                :filter.sync="filters"
                :mkos="mkos"
                @change="getItemsByFilter"
        ></transaction-filter>
        <div>
            <v-card-title class="px-0 pb-1 pt-1">Транзакции</v-card-title>
            <v-tabs v-model="statusStep">
                <v-tab href="#tab-all">Все</v-tab>
                <v-tab href="#tab-10">Успешные</v-tab>
                <v-tab href="#tab-0">Ошибка транзакции</v-tab>
                <v-tab href="#tab-1">Странзакция создан</v-tab>
            </v-tabs>
        </div>
        <v-data-table
                :custom-sort="item => item"
                :headers="headers"
                :items="items"
                :options.sync="options"
                disable-pagination
                hide-default-footer>
            <template v-slot:body="{items}">
                <tbody>
                <tr :key="item.id" v-for="(item,i) in items">
                    <td>{{ getNumber(i) }}</td>
                    <td>
                        <v-btn @click="$router.push({name: 'credit-item', params: {id: item.credit_id}})" small>
                            {{ item.credit_number }}
                        </v-btn>
                    </td>
                    <td>{{ item.first_name + ' ' + item.last_name }}</td>
                    <td>{{ item.amount|money}}</td>
                    <td>{{ item.current_debt|money}}</td>
                    <td>{{ item.payment_type|parsePaymentType}}</td>
                    <td>
                        <div v-if="item.pan" class="logo-img-width">
                            <img v-if="item.service === 'paymo'" src="@/assets/images/paymo.png" :alt="item.service"/>
                            <img v-if="item.service === 'myuzcard'" src="@/assets/images/myuzcard.png" :alt="item.service"/>
                        </div>
                    </td>

                    <td>{{ item.pan}}</td>
                    <td>
                        <v-chip :color="item.state === 10 ? 'primary' : 'red'" class="ma-2" label text-color="white">
                            {{ item.status_name }}
                        </v-chip>
                    </td>
                    <td>{{ item.created_at|parseTimeWithTimeZone}}</td>
                    <td>
                        <v-tooltip right>
                            <template #activator="{on, attrs}">
                                <div class="d-inline-block text-truncate" style="max-width: 150px;" v-bind="attrs" v-on="on">
                                    {{ item.resp_message }}
                                </div>
                            </template>
                            <span>{{ item.resp_message }}</span>
                        </v-tooltip>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-data-table>
        <v-pagination
                :length="options.last_page"
                v-if="options.last_page > 1"
                v-model="options.page"
        ></v-pagination>
    </div>
</template>

<script>

	import TransactionFilter from "@/components/transaction/TransactionFilter";
	import {debounce} from "@/utils/pureFunctions";

	export default {
		components: {TransactionFilter},
		data() {
			return {
				mkos: [],
				credits: [],
				headers: [
					{text: '№', value: 'page'},
					{text: 'Кредит номер', value: 'credit_id'},
					{text: 'Ф.И.О', value: 'name'},
					{text: 'Cумма списания', value: 'amount_credit'},
					{text: 'Задолженность', value: 'amount_credit'},
					{text: 'Тип', value: 'payment_type'},
					{text: 'Сервис', value: 'payment_service'},
					{text: 'Номер карты', value: 'pan'},
					{text: 'Статус', value: 'status_name'},
					{text: 'Дата', value: 'date'},
					{text: 'Описание', value: 'resp_message'},
				],
				items: [],
				options: {
					last_page: 1,
					page: 1
				},
				filters: {},
				current: 1,
				statusStep: 0
			}
		},
		methods: {
			async getItemsByFilter(filter) {
				this.filters = filter
				this.options.page = 1;
				this.$showLoading()
				await this.getItems(filter)
				this.$clearLoading()
			},
			async getCredits() {
				try {
					const {data: {data}} = await this.$http.get('admin/credits')
					this.credits = data
				} catch (e) {
					this.$setResponseError({error: e})
				}
			},
			async getItems(filter) {
				let params = {
					...this.options
				}
				if (filter) {
					params = {...params, ...filter}
				}
				try {
					const {data: {data, links: {last_page, current_page}}} = await this.$http.get('admin/debit-history/transactions', {
						params
					})
					this.items = data.map(item => {
						if (item.resp_status === "ERR" && item.resp_message) {
							let message = item.resp_message.split(':');
							if (message && message.length > 1)
								item.resp_message = message[1];
						}
						return item;
					})
					this.options.last_page = last_page
					this.current = current_page;
					this.$clearLoading()
				} catch (e) {
					this.$setResponseError({error: e})
					this.$clearLoading()
				} finally {
				}
			},
			getNumber(i) {
				return (this.current - 1) * 50 + i + 1;
			},
			getItemsWithLoading: debounce(async function () {
				this.$showLoading()
				await this.getItems(this.filters)
				this.$clearLoading()
			}, 50)
		},
		async created() {
			this.$showLoading()
			try {
				await this.getItems()
				this.mkos = await this.$store.dispatch('getMkos')
				await this.getCredits()
			} catch (e) {
				this.$setResponseError({error: e})
			} finally {
				this.$clearLoading()
			}
		},
		watch: {
			async "options.page"() {
				this.$showLoading()
				await this.getItems(this.filters)
				this.$clearLoading()
			},
			"statusStep": async function (val) {
				const status = val.substr(4);
				this.filters.state = status === 'all' ? null : status;
				this.options.page = 1;
				this.$showLoading()
				await this.getItems(this.filters)
				this.$clearLoading()

			}
		},
	}
</script>
<style>
    .logo-img-width img{
        max-width: 80px;
    }
</style>
